<template>
    <div class="authorization-container">
        <div class="authorization-form-container">
            <div class="authorization-form">

                <div class="form-entry">
                    <div class="entry-label">სახელმწიფო ნომერი</div>
                    <div class="input-with-action">
                        <button @click="getAuthCode" class="icon-button">
                            <loading v-if="loading.stateNumber" :width="25"/>
                            <span v-else class="taxi-arrow"></span>
                        </button>
                        <input v-model="stateNumber" @keyup="clearStateNumber" type="text" maxlength="7">
                    </div>
                    <div class="error-message"></div>
                </div>

                <div class="form-entry">
                    <div class="entry-label">სმს კოდი</div>
                    <input v-model="authCode" type="text" maxlength="4">
                    <div class="error-message"></div>
                </div>

                <button @click="authorize" class="button">
                    <loading v-if="loading.authCode" :width="30"/>
                    <template v-else>
                        დადასტურება
                    </template>
                </button>

            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {SET_TOKENS} from "../store/types";
    import Loading from "../components/Loading";
    import storage from "../services/storage.service";
    export default {
        data() {
            return {
                stateNumber: null,
                authCode: null,
                loading: {
                    stateNumber: false,
                    authCode: false
                }
            }
        },
        methods:{
            getAuthCode() {
                this.loading.stateNumber = true;
                let requestData = {
                    url: 'api/taxi/driver/auth/sms/send',
                    method: 'POST',
                    data: { objectStateN: this.stateNumber}
                };
                this.$apiService.sendRequest(requestData).then((resp)=>{

                    this.$eventBus.$emit('showAlert', {
                        content: resp.data.successMessage,
                        config: {type: 'success'}
                    });

                }).catch(error => {
                    this.$eventBus.$emit('showAlert', {
                        content: error.response ? error.response.data.errorMessages.join("\r\n") : error.message,
                        config: {type: 'error'}
                    });
                }).finally(()=>{
                    this.loading.stateNumber = false;
                });
            },


            authorize(){
                this.loading.authCode = true;
                let requestData = {
                    url: 'api/taxi/driver/auth',
                    method: 'POST',
                    data: {
                        objectStateN: this.stateNumber,
                        authCode: this.authCode
                    }
                };

                this.$apiService.sendRequest(requestData).then(resp => {
                    this.$apiService.mountResponseInterceptor();
                    this.$store.commit(SET_TOKENS, {accessToken: resp.data.accessToken, refreshToken:  resp.data.refreshToken});
                    storage.saveItem('userData', JSON.stringify(resp.data.data));
                    this.$router.push({name: 'map'})
                }).catch(error => {
                    this.$eventBus.$emit('showAlert', {
                        content: error.response ? error.response.data.errorMessages.join("\r\n") : error.message,
                        config: {type: 'error'}
                    });
                }).finally(()=>{
                    this.loading.authCode = false;
                });
            },

            clearStateNumber(e){
                this.stateNumber = e.target.value.replace(/[^a-z0-9]/gi,'');
            }
        },
        computed: {
            ...mapGetters(['isAuthenticated']),
        },
        components: {
            Loading
        },
        created() {
            if(this.isAuthenticated) this.$router.push({name: 'map'});
        }
    }
</script>

<style lang="scss" scoped>
    .authorization-container{
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        background: url("../assets/images/map.svg");
        background-repeat: no-repeat;
        background-size: cover;
        padding: 20px 0;

        .authorization-form-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 80%;
            padding: 50px 30px;
            border-radius: $border-radius;
            background-color: $white;
            box-shadow: $box-shadow;
        }

        .authorization-form {
            width: 80%;
        }

        .form-entry{
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;

            & + .form-entry {
                margin-top: 20px;
            }

            .entry-label {
                font-size: .85rem;
                color: $gray-5;
                margin-bottom: 8px;
            }

            .input-with-action {
                position: relative;
                display: flex;
                justify-content: center;
                width: 100%;

                input{
                    text-transform: uppercase;
                }

                .icon-button {
                    position: absolute;
                    right: 5px;
                    top: 50%;
                    transform: translateY(-50%);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 38px;
                    height: 38px;
                    border-radius: 50%;
                    border: none;
                    background-color: $secondary-color;
                    color: $white;
                }
            }

            input{
                height: 48px;
                padding: 15px;
                border-radius: 24px;
                border: 2px solid $border-color;
                width: 100%;
                text-align: center;
                font-size: 1.1rem;
            }
        }

        .button{
            margin-top: 80px;
            width: 100%;
        }
    }
</style>
